/**
 * Per-block dynamic import boundaries — one chunk per implementation.
 * Keys must match BLOCKS_REGISTRY `component` values exactly.
 */

/** @type {Record<string, () => Promise<{ default: React.ComponentType<unknown> }>>} */
export const BLOCK_COMPONENT_LOADERS = {
  Card: () =>
    import('../Blocks/card/Card').then((m) => ({ default: m.Card })),
  SupportingNotesCard: () =>
    import('../Blocks/card/SupportingNotesCard').then((m) => ({
      default: m.SupportingNotesCard,
    })),
  Badge: () =>
    import('../Blocks/badge/Badge').then((m) => ({ default: m.Badge })),
  Callout: () =>
    import('../Blocks/callout/Callout').then((m) => ({ default: m.Callout })),
  Quote: () =>
    import('../Blocks/quote/Quote').then((m) => ({ default: m.Quote })),
  Rule: () =>
    import('../Blocks/rule/Rule').then((m) => ({ default: m.Rule })),
  ZoneGrid: () =>
    import('../Blocks/zone/ZoneGrid').then((m) => ({ default: m.ZoneGrid })),
  WarningBox: () =>
    import('../Blocks/warning/WarningBox').then((m) => ({
      default: m.WarningBox,
    })),
  DailyRow: () =>
    import('../Blocks/daily/DailyRow').then((m) => ({ default: m.DailyRow })),
  StepRow: () =>
    import('../Blocks/steps/StepRow').then((m) => ({ default: m.StepRow })),
  Steps: () =>
    import('../Blocks/steps/Steps').then((m) => ({ default: m.StepsSection })),
  Hero: () =>
    import('../Blocks/hero/Hero').then((m) => ({ default: m.Hero })),
  Tabs: () =>
    import('../Blocks/tabs/Tabs').then((m) => ({ default: m.Tabs })),
  RichText: () =>
    import('../Blocks/rich-text/RichText').then((m) => ({ default: m.RichText })),
  InsightBlock: () =>
    import('../Blocks/insight/InsightBlock').then((m) => ({
      default: m.InsightBlock,
    })),
  SummaryBlock: () =>
    import('../Blocks/summary/SummaryBlock').then((m) => ({
      default: m.SummaryBlock,
    })),
  QuestionBlock: () =>
    import('../Blocks/question/QuestionBlock').then((m) => ({
      default: m.QuestionBlock,
    })),
  ReferenceBlock: () =>
    import('../Blocks/reference/ReferenceBlock').then((m) => ({
      default: m.ReferenceBlock,
    })),
  TimelineBlock: () =>
    import('../Blocks/timeline/TimelineBlock').then((m) => ({
      default: m.TimelineBlock,
    })),
  InterviewerTest: () =>
    import('../Blocks/interviewer/InterviewerTest').then((m) => ({
      default: m.InterviewerTest,
    })),
  LessonTracker: () =>
    import('../Blocks/lesson/LessonTracker').then((m) => ({
      default: m.LessonTracker,
    })),
  CodeBlock: () =>
    import('../Blocks/code/CodeBlock').then((m) => ({ default: m.CodeBlock })),
  MediaBlock: () =>
    import('../Blocks/media/MediaBlock').then((m) => ({ default: m.MediaBlock })),
}
